<template>
  <div class="d-flex flex-column align-items-start mt-2 pb-2 white-color">
    <div class="gamerule-content-header">{{title}}</div>

    <div v-for="(data, i) in value" :key="i" class="w-100">
      <div v-if="data.type === 'text'"
        class="gamerule-content-description font-desc mt-1 text-left"
        :class="data.class">
        {{data.text}}
      </div>

      <div v-if="data.type === 'textSlot'"
        class="gamerule-content-description font-slot mt-1 text-left"
        :class="data.class">
        {{data.text}}
      </div>
      <div v-if="data.type === 'textDt'"
        class="gamerule-content-description font-slot gamerule-context-img-container"
        :class="data.class">
        <div class="mt-2 mb-2">
          <span>{{ data.text }}</span>
          <span class="textColor-Hr-bule">{{ data.textCol }}</span>
          <span>{{ data.text2 }}</span>
          <span class="red-color">{{ data.textCol2 }}</span>
          <span>{{ data.text3 }}</span>
        </div>
      </div>

      <div v-if="data.type === 'textHrColor1'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-Hr-bule">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
      </div>
      <div v-if="data.type === 'textHrColor2'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-Hr-pink">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
      </div>
      <div v-if="data.type === 'textHrColor3'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-Hr-pink">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
        <span class="textColor-fs-red">{{ data.textCol2 }}</span>
        <span>{{ data.text3 }}</span>
        <span class="textColor-Hr-yellow">{{ data.textCol3 }}</span>
        <span>{{ data.text4 }}</span>
      </div>
      <div v-if="data.type === 'textHrColor4'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-fs-red">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
        <span class="textColor-Hr-yellow">{{ data.textCol2 }}</span>
        <span>{{ data.text3 }}</span>
      </div>

      <div v-if="data.type === 'textBgRedGreen'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-fs-red">{{ data.textCol }}</span>
        <span class="textColor-bg2">{{ data.textCol2 }}</span>
        <span class="textColor-fs-green">{{ data.textCol3 }}</span>
        <span>{{ data.text2 }}</span>
      </div>

      <div v-if="data.type === 'textBg1ColorNew'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span class="textColor-bg2">{{ data.textCol }}</span>
        <span>{{ data.text }}</span>
      </div>

      <div v-if="data.type === 'textBg1Color'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-bg2">{{ data.textCol }}</span>
      </div>

      <div v-if="data.type === 'textBg2Color'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-bg2">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
      </div>

      <div v-if="data.type === 'textBg2Color2'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span>{{ data.text }}</span>
        <span class="textColor-bg2">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
        <span class="textColor-bg2">{{ data.textCol2 }}</span>
        <span>{{ data.text3 }}</span>
      </div>

      <div v-if="data.type === 'textBg2Color2New'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span class="textColor-bg2">{{ data.textCol }}</span>
        <span>{{ data.text }}</span>
        <span class="textColor-bg2">{{ data.textCol2 }}</span>
      </div>

      <div v-if="data.type === 'textBg2ColorRed'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        <span class="textColor-fs-red">{{ data.textCol }}</span>
        <span>{{ data.text }}</span>
        <span class="textColor-bg2">{{ data.textCol2 }}</span>
      </div>

      <div v-if="data.type === 'textBg2'"
        class="gamerule-content-description font-bg2 mt-1 text-left"
        :class="data.class">
        {{data.text}}
      </div>

      <div v-if="data.type === 'ruleGame-bingo2'" class="my-2">
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{ data.text }}</span>
          <span class="textColor-bg2">{{ data.textCol }}</span>
          <span>{{data.textCon}}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{ data.text2 }}</span>
          <span class="textColor-bg2">{{ data.textCol2 }}</span>
          <span>{{data.textCon2}}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{ data.text3 }}</span>
          <span class="textColor-bg2">{{ data.textCol3 }}</span>
          <span>{{data.textCon3}}</span>
          <span class="textColor-bg2">{{ data.textCol3_2 }}</span>
          <span>{{data.textCon3_2}}</span>
        </div>
        <div class="d-flex justify-content-center gamerule-context-img-container my-2 py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image2" />
          </div>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span class="textColor-bg2">{{ data.textCol4 }}</span>
          <span>{{ data.text4 }}</span>
          <span class="textColor-bg2">{{ data.textCol4_2 }}</span>
          <span>{{data.textCon4}}</span>
          <span class="textColor-bg2">{{ data.textCol4_3 }}</span>
          <span>{{data.textCon4_2}}</span>
          <span class="textColor-bg2">{{ data.textCol4_4 }}</span>
          <span>{{data.textCon4_3}}</span>
          <span class="textColor-bg2">{{ data.textCol4_5 }}</span>
          <span>{{data.textCon4_4}}</span>
          <span class="textColor-bg2">{{ data.textCol4_6 }}</span>
          <span>{{data.textCon4_5}}</span>
          <span class="textColor-bg2">{{ data.textCol4_7 }}</span>
        </div>
        <div class="gamerule-context-img-container my-2 justify-content-start">
          <div>
            <img class="p-2 gamerule-single-img image"
              :class="data.class1"
              :src="data.image3" />
          </div>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{ data.text5 }}</span>
          <span class="textColor-bg2">{{ data.textCol5 }}</span>
          <span>{{data.textCon5}}</span>
          <span class="textColor-bg2">{{ data.textCol5_2 }}</span>
          <span>{{data.textCon5_2}}</span>
          <span class="textColor-bg2">{{ data.textCol5_3 }}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.textCon5_3}}</span>
          <span class="textColor-bg2">{{ data.textCol5_4 }}</span>
          <span>{{data.textCon5_4}}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span class="textColor-bg2">{{ data.textCol5_5 }}</span>
          <span>{{data.textCon5_5}}</span>
          <span class="textColor-bg2">{{ data.textCol5_6 }}</span>
          <span>{{data.textCon5_6}}</span>
          <span class="textColor-bg2">{{ data.textCol5_7 }}</span>
          <span>{{data.textCon5_7}}</span>
          <span class="textColor-bg2">{{ data.textCol5_8 }}</span>
        </div>
        <div class="d-flex justify-content-center gamerule-context-img-container my-2 py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image4" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image5" />
          </div>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.text6}}</span>
          <span class="textColor-bg2">{{ data.textCol6 }}</span>
          <span>{{data.textCon6}}</span>
        </div>
          <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span class="textColor-bg2">{{ data.textCol6_2 }}</span>
          <span>{{data.textCon6_2}}</span>
          <span class="textColor-bg2">{{ data.textCol6_3 }}</span>
          </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span class="textColor-bg2">{{ data.textCol6_4 }}</span>
          <span>{{data.textCon6_3}}</span>
        </div>
        <div class="d-flex justify-content-center gamerule-context-img-container my-2 py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image6" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image7" />
          </div>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span class="textColor-bg2">{{ data.textCol7 }}</span>
          <span>{{data.text7}}</span>
        </div>
        <div class="d-flex justify-content-center gamerule-context-img-container my-2 py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image8" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image9" />
          </div>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.text8}}</span>
          <span class="textColor-bg2">{{ data.textCol8 }}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.textCon8}}</span>
          <span class="textColor-bg2">{{ data.textCol8_2 }}</span>
          <span>{{data.textCon8_2}}</span>
          <span class="textColor-bg2">{{ data.textCol8_3 }}</span>
          <span>{{data.textCon8_3}}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.textCon8_4}}</span>
          <span class="textColor-bg2">{{ data.textCol8_4 }}</span>
          <span>{{data.textCon8_5}}</span>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.textCon8_6}}</span>
          <span class="textColor-bg2">{{ data.textCol8_5 }}</span>
          <span>{{data.textCon8_7}}</span>
        </div>
        <div class="d-flex justify-content-center gamerule-context-img-container my-2 py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image10" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image11" />
          </div>
        </div>
      </div>

      <div v-if="data.type === 'ruleGame-fruitslot'"
      class="gamerule-content-description font-desc mt-1 text-center"
      :class="data.class">{{data.class}}</div>

      <div v-if="data.type === 'text-header'"
        class="gamerule-content-description-header font-desc mt-1 text-left"
        :class="data.class">
        {{data.text}}
      </div>

      <div v-if="data.type === 'textSub'"
        class="gamerule-content-description-sub font-desc"
        style="text-align: left" :class="data.class">
        {{data.text}}
      </div>

      <p v-if="data.type === 'textSubcolor'"
        class="gamerule-content-description-sub font-desc  text-left"
        :class="data.classMain">
        <span>{{data.textSub}}</span>
        <span class="gamerule-content-description-subcolor font-desc"
          :class="data.class1">
          {{data.textSubcolor}}</span>
        <span>{{data.textSub1}}</span>
        <span class="gamerule-content-description-subcolor font-desc"
          :class="data.class2">
          {{data.textSubcolor1}}</span>
        <span>{{data.textSub2}}</span>
        <span class="gamerule-content-description-subcolor font-desc"
          :class="data.class3">
          {{data.textSubcolor2}}</span>
        <span>{{data.textSub3}}</span>
      </p>

      <p v-if="data.type === 'textSubcolor-football'"
        class="gamerule-content-description-sub font-desc"
        :class="data.classMain">
        <span>{{data.textSub}}</span>
        <span class="gamerule-content-description-football font-desc"
          :class="data.class1">
          {{data.textSubcolor}}</span>
        <span>{{data.textSub1}}</span>
        <span class="gamerule-content-description-football font-desc"
          :class="data.class2">
          {{data.textSubcolor1}}</span>
        <span>{{data.textSub2}}</span>
        <span class="gamerule-content-description-football font-desc"
          :class="data.class3">
          {{data.textSubcolor2}}</span>
        <span>{{data.textSub3}}</span>
      </p>

      <p v-if="data.type === 'textSubcolor-bingo'"
        class="gamerule-content-description-sub font-desc  text-left"
        :class="data.classMain">
        <span>{{data.textSub}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class1">
          {{data.textSubcolor}}</span>
        <span>{{data.textSub1}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class2">
          {{data.textSubcolor1}}</span>
        <span>{{data.textSub2}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class3">
          {{data.textSubcolor2}}</span>
        <span>{{data.textSub3}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class4">
          {{data.textSubcolor3}}</span>
        <span>{{data.textSub4}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class5">
          {{data.textSubcolor4}}</span>
        <span>{{data.textSub5}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class6">
          {{data.textSubcolor5}}</span>
        <span>{{data.textSub6}}</span>
        <span class="gamerule-content-description-subcolor-bingo mr-2"
          :class="data.class7">
          {{data.textSubcolor6}}</span>
        <span>{{data.textSub7}}</span>

      </p>

      <div v-if="data.type === 'rowImageText'"
      class="gamerule-context-img-container my-2">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" />
            <div>
              <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text }}
              </div>
            </div>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image2" />
              <div>
                <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text2 }}
                </div>
              </div>
          </div>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class3"
              :src="data.image3" />
            <div>
              <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text3 }}
              </div>
            </div>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class4"
              :src="data.image4" />
              <div>
                <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text4 }}
                </div>
              </div>
          </div>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class5"
              :src="data.image5" />
            <div>
              <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text5 }}
              </div>
            </div>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class6"
              :src="data.image6" />
              <div>
                <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text6 }}
                </div>
              </div>
          </div>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class7"
              :src="data.image7" />
            <div>
              <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text7 }}
              </div>
            </div>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class8"
              :src="data.image8" />
              <div>
                <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text8 }}
                </div>
              </div>
          </div>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class9"
              :src="data.image9" />
            <div>
              <span class="font-slot">{{data.text9}}</span>
            </div>
            <div>
              <span class="font-slot">{{data.text91}}</span>
            </div>
          </div>
          <div>
            <img class="p-2 gamerule-single-img "
              :class="data.class10"
              :src="data.image10" />
              <div>
                <div class="gamerule-content-img-description font-slot mb-2">
            {{ data.text10 }}
                </div>
              </div>
          </div>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div class="p-5">
            <img class="gamerule-single-img"
              :class="data.class11"
              :src="data.image11" />
            <div>
              <div>
                <span class="font-slot">{{data.text11}}</span>
              </div>
              <div>
                <span class="font-slot">{{data.text111}}</span>
              </div>
            </div>
          </div>
          <div class="p-5">
            <img class="gamerule-single-img"
                :class="data.class12"
                :src="data.image12" />
            <div>
              <span class="font-slot">{{data.text12}}</span>
            </div>
            <div>
              <span class="font-slot">{{data.text121}}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="data.type === 'image'"
        class="gamerule-context-img-container my-2 justify-content-start"
        :class="data.classMain">
        <div>
          <img class="p-2 gamerule-single-img"
            :class="data.class"
            :src="data.image"
            alt="6cards_rules1"/>
        </div>
      </div>

      <div
        v-if="data.type === 'imageTextBcr'"
        class="gamerule-context-img-container my-2 justify-content-start"
        :class="data.classMain">
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.text}}</span>
          <span class="textColor-bg2">{{ data.textCol }}</span>
          <span>{{data.text2}}</span>
        </div>
        <div>
          <img class="p-2 gamerule-single-img"
            :class="data.class"
            :src="data.image"/>
        </div>
      </div>

      <div
        v-if="data.type === 'imageTextBcr2'"
        class="gamerule-context-img-container my-2 justify-content-start"
        :class="data.classMain">
        <div class="gamerule-content-description font-bg2 mt-1 text-left">
          <span>{{data.text}}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol }}</span>
          <span>{{data.text2}}</span>
          <span class="textColor-fs-red">{{ data.textCol2 }}</span>
          <span>{{data.text3}}</span>
        </div>
        <div>
          <img class="p-2 gamerule-single-img"
            :class="data.class"
            :src="data.image"/>
        </div>
      </div>

      <div
        v-if="data.type === 'imageTextBcr3'"
        class="gamerule-context-img-container my-2 justify-content-start"
        :class="data.classMain">
        <div class="gamerule-content-description font-bg2 mt-1 text-center">
          <span>{{data.text}}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol }}</span>
          <span>{{data.text2}}</span>
        </div>
        <div>
          <img class="p-2 gamerule-single-img"
            :class="data.class"
            :src="data.image"/>
        </div>
      </div>

      <div
        v-if="data.type === 'imageTextBcr5'"
        class="gamerule-context-img-container my-2"
        :class="data.classMain">
        <div class="d-flex justify-content-center">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image"/>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2"/>
          </div>
        </div>
        <div class="gamerule-content-description font-bg2 mt-1 text-center">
          <span>{{data.text}}</span>
          <span class="textColor-fs-red">{{ data.textCol }}</span>
          <span>{{data.text2}}</span>
          <span class="textColor-fs-green">{{ data.textCol2 }}</span>
          <span>{{data.text3}}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol3 }}</span>
          <span>{{data.text4}}</span>
          <span class="textColor-Bcr-purple">{{ data.textCol4 }}</span>
          <span>{{data.text5}}</span>
        </div>
      </div>

      <div
        v-if="data.type === 'imageTextBcr4'"
        class="gamerule-context-img-container my-2 justify-content-start"
        :class="data.classMain">
        <div class="gamerule-content-description font-bg2 mt-1 text-center">
          <span>{{data.text}}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol }}</span>
          <span>{{data.text2}}</span>
          <span class="textColor-fs-red">{{ data.textCol2 }}</span>
           <span>{{data.text3}}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol3 }}</span>
          <span>{{data.text4}}</span>
          <span class="textColor-fs-red">{{ data.textCol4 }}</span>
          <span>{{data.text5}}</span>
        </div>
        <div>
          <img class="p-2 gamerule-single-img"
            :class="data.class"
            :src="data.image"/>
        </div>
      </div>

      <div v-if="data.type === 'imageTextBcr6'" class="gamerule-context-img-container my-2">
        <div class="gamerule-content-img-description text-center font-desc" :class="data.class">
          <span>{{ data.text }}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol }}</span>
          <span>{{ data.text2 }}</span>
          <span class="textColor-fs-red">{{ data.textCol2 }}</span>
          <span>{{ data.text3 }}</span>
          <span class="textColor-fs-green">{{ data.textCol3 }}</span>
          <span>{{ data.text4 }}</span>
        </div>
        <div class="d-flex align-items-center">
          <div class="col-6">
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class2" />
          </div>
          <div class="gamerule-content-img-description font-big text-left">
            <div>
              <span class="textColor-Hr-bule">{{ data.textCol4 }}</span>
              <span>{{ data.text5 }}</span>
            </div>
            <div>
              <span class="textColor-fs-red">{{ data.textCol5 }}</span>
              <span>{{ data.text6 }}</span>
            </div>
            <div>
              <span class="textColor-fs-green">{{ data.textCol6 }}</span>
              <span>{{ data.text7 }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextBcr7'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center">
          <div class="col-6">
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class2" />
          </div>
          <div class="font-big text-left">
            <div>
              <span class="textColor-Hr-bule">{{ data.textCol }}</span>
              <span>{{ data.text }}</span>
            </div>
            <div>
              <span class="textColor-fs-red">{{ data.textCol2 }}</span>
              <span>{{ data.text2 }}</span>
            </div>
          </div>
        </div>
        <div class="gamerule-content-img-description text-center font-desc" :class="data.class">
          <span>{{ data.text3 }}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol3 }}</span>
          <span>{{ data.text4 }}</span>
          <span class="textColor-fs-red">{{ data.textCol4 }}</span>
          <span>{{ data.text5 }}</span>
          <span class="textColor-fs-red">{{ data.textCol5 }}</span>
          <span>{{ data.text6 }}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol6 }}</span>
          <span>{{ data.text7 }}</span>
          <span class="textColor-fs-red">{{ data.textCol7 }}</span>
          <span>{{ data.text8 }}</span>
          <span class="textColor-Bcr-blue">{{ data.textCol8 }}</span>
          <span>{{ data.text9 }}</span>
        </div>
      </div>

      <div v-if="data.type === 'dtPart'">
        <div class="d-flex">
          <div class="my-2"
          :class="data.class">
            <div class="gamerule-context-img-container p-2">
              <img width="100%" :src="data.image"/>
              <img class="mt-1" width="100%" :src="data.image2"/>
            </div>
          </div>
          <div class="text-left font-desc col-5 pl-4" :class="data.class">
            <span>{{data.text1}}</span><br>
            <span>{{data.text2}}</span><br>
            <span>{{data.text3}}</span><br>
            <span>{{data.text4}}</span><br>
            <span>{{data.text5}}</span><br>
            <span>{{data.text6}}</span><br>
            <span class="ml-2">{{data.text7}}</span><br>
            <span class="ml-2">{{data.text8}}</span><br>
            <span class="ml-2">{{data.text9}}</span><br>
            <span>{{data.text10}}</span><br>
            <span>{{data.text11}}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageNoborder'" class="gamerule-single-img-13cards my-2">
        <div :class="data.class">
          <img class="p-3" width="100%" :src="data.image" alt="6cards_rules1"/>
        </div>
      </div>
      <div v-if="data.type === 'imageNoborderSlot'" class="gamerule-single-img-13cards my-2">
        <div :class="data.class">
          <img class="rule-slot ml-3 mt-2 mb-2" width="100%" :src="data.image"/>
        </div>
      </div>

      <div v-if="data.type === 'twoImage'" class="gamerule-context-img-container my-2">
        <div class="d-flex justify-content-center">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image"
              alt="6cards_rules1" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2"
              alt="6cards_rules2" />
          </div>
        </div>
      </div>

      <div v-if="data.type === 'twoImageText'" class="gamerule-context-img-container my-4">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image"/>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2"/>
          </div>
        </div>
        <div>
          <div class="gamerule-content-img-description font-desc mb-2">
            {{ data.text }}
          </div>
        </div>
      </div>

      <div v-if="data.type === 'twoImageTextDt'" class="gamerule-context-img-container my-4">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image"/>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2"/>
          </div>
        </div>
        <div>
          <div class="gamerule-content-img-description font-desc mb-2">
            <span>{{ data.text }}</span>
            <span class="textColor-Hr-bule">{{ data.textCol }}</span>
            <span>{{ data.text2 }}</span>
            <span class="textColor-fs-green">{{ data.textCol2 }}</span>
            <span>{{ data.text3 }}</span>
            <span class="textColor-fs-red">{{ data.textCol3 }}</span>
            <span>{{ data.text4 }}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextDt3'" class="gamerule-context-img-container my-4">
        <div class="justify-content-center py-2 px-4">
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" />
        </div>
        <div>
          <div class="gamerule-content-img-description font-desc mb-2">
            <span>{{ data.text }}</span>
            <span class="textColor-Hr-bule">{{ data.textCol }}</span>
            <span>{{ data.text2 }}</span>
            <span class="textColor-fs-red">{{ data.textCol2 }}</span>
            <span>{{ data.text3 }}</span>
            <span class="textColor-fs-green">{{ data.textCol3 }}</span>
            <span>{{ data.text4 }}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'twoImageTextDt2'" class="gamerule-context-img-container my-4">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image"/>
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2"/>
          </div>
        </div>
        <div>
          <div class="gamerule-content-img-description font-desc mb-2">
            <span>{{ data.text }}</span>
            <span class="textColor-Hr-bule">{{ data.textCol }}</span>
            <span>{{ data.text2 }}</span>
            <span class="textColor-fs-red">{{ data.textCol2 }}</span>
            <span>{{ data.text3 }}</span>
            <span class="textColor-fs-green">{{ data.textCol3 }}</span>
            <span>{{ data.text4 }}</span>
            <span class="textColor-Hr-bule">{{ data.textCol4 }}</span>
            <span>{{ data.text5 }}</span>
            <span class="textColor-fs-red">{{ data.textCol5 }}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'twoImageTextNew'" class="gamerule-context-img-container my-4">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" alt="6cards_rules1" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2" alt="6cards_rules2" />
          </div>
        </div>
        <div>
          <span class="textHighlight mr-2">{{data.textHead}}</span>
          <span class="font-desc">{{ data.text }}</span>
        </div>
      </div>

      <div v-if="data.type === 'hightlightText'" class="left my-4">
        <div :class="data.class">
          <span class="textHighlight mr-2 h-textSize">{{data.textHead}}</span>
          <span class="font-desc">{{ data.text }}</span>
        </div>
      </div>

      <div v-if="data.type === 'threeImage'" class="gamerule-context-img-container my-2">
        <div class="d-flex justify-content-center">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image"
              alt="6cards_rules1" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image2"
              alt="6cards_rules2" />
          </div>
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image3"
              alt="6cards_rules2" />
          </div>
        </div>
      </div>

      <div v-if="data.type === 'rulePayout-horse'" class="gamerule-context-img-container my-2
      font-bg2">
        <div class="mb-3 text-left ml-3 mt-3">
        <span>{{ data.text }}</span>
        <span class="textColor-Hr-yellow">{{ data.textCol }}</span>
        <span>{{ data.text2 }}</span>
        <span class="textColor-Hr-pink">{{ data.textCol2 }}</span>
        <span>{{ data.text3 }}</span>
        <span class="textColor-fs-red">{{ data.textCol3 }}</span>
        <span>{{ data.text4 }}</span>
        <span class="textColor-Hr-yellow">{{ data.textCol4 }}</span>
        <span>{{ data.text5 }}</span>
        <span class="textColor-Hr-yellow">{{ data.textCol5 }}</span>
        <span>{{ data.text6 }}</span>
        <span class="textColor-Hr-yellow">{{ data.textCol6 }}</span>
        <span>{{ data.text7 }}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" />
          </div>
        </div>
      </div>

      <div v-if="data.type === 'ruleGame-horse'" class="gamerule-context-img-container my-2">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text }}</span>
          <span class="textColor-fs-red font-slot">{{ data.textCol }}</span>
          <span class="font-slot">{{data.textCon}}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4 ">
          <div>
            <img class="p-2 gamerule-single-img w-30"
              :src="data.image2" />
            <img class="p-2 gamerule-single-img w-30"
              :src="data.image3" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-bg2">{{ data.text2 }}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class4"
              :src="data.image4" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text3 }}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class5"
              :src="data.image5" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text4 }}</span>
        </div>
      </div>

      <div v-if="data.type === 'fiveImageTextNew'" class="gamerule-context-img-container my-2">
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class"
              :src="data.image" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text }}</span>
          <span class="textColor-fs-green font-slot">{{ data.textCol }}</span>
          <span class="font-slot">{{data.textCon}}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class2"
              :src="data.image2" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text2 }}</span>
          <span class="textColor-fs-green font-slot">{{ data.textCol2 }}</span>
          <span class="font-slot">{{data.textCon2}}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class3"
              :src="data.image3" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text3 }}</span>
          <span class="textColor-fs-green font-slot">{{ data.textCol3 }}</span>
          <span class="font-slot">{{data.textCon3}}</span>
          <span class="textColor-fs-red font-slot">{{ data.textCol3_2 }}</span>
         <span class="font-slot">{{data.textCon3_2}}</span>
         <span class="textColor-fs-red font-slot">{{ data.textCol3_3 }}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class4"
              :src="data.image4" />
          </div>
        </div>
        <div class="mb-3">
          <span class="font-slot">{{ data.text4 }}</span>
          <span class="textColor-fs-green font-slot">{{ data.textCol4 }}</span>
          <span class="font-slot">{{data.textCon4}}</span>
          <span class="textColor-fs-red font-slot">{{ data.textCol4_2 }}</span>
          <span class="font-slot">{{data.textCon4_2}}</span>
          <span class="textColor-fs-red font-slot">{{ data.textCol4_3 }}</span>
        </div>
        <div class="d-flex justify-content-center py-2 px-4">
          <div>
            <img class="p-2 gamerule-single-img"
              :class="data.class5"
              :src="data.image5" />
          </div>
        </div>
        <div class="mb-5">
          <span class="font-slot">{{ data.text5 }}</span>
          <span class="textColor-fs-green font-slot">{{ data.textCol5 }}</span>
          <span class="font-slot">{{data.textCon5}}</span>
          <span class="textColor-fs-red font-slot">{{ data.textCol5_2 }}</span>
          <span class="font-slot">{{data.textCon5_2}}</span>
        </div>
      </div>

      <div v-if="data.type === 'imageTextFish'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column" :class="data.classMain">
          <div class="gamerule-content-img-description text-center font-head">
            {{ data.textHead }}
          </div>
          <div>
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class" />
          </div>
          <div class="gamerule-content-img-description font-desc">
            {{ data.text }}
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextDt'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column" :class="data.classMain">
          <div class="gamerule-content-img-description text-center font-desc">
            <span>{{ data.text }}</span>
          </div>
          <div class="gamerule-content-img-description text-center font-desc">
            <span>{{ data.text2 }}</span>
          </div>
          <div>
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class" />
          </div>
          <div class="gamerule-content-img-description font-desc">
            <span class="textColor-fs-red">{{ data.text3 }}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextDt2'" class="gamerule-context-img-container my-2">
        <div class="gamerule-content-img-description text-center font-desc" :class="data.class">
            <span>{{ data.text }}</span>
        </div>
        <div class="d-flex align-items-center">
          <div class="col-6">
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class2" />
          </div>
          <div class="gamerule-content-img-description font-big text-left">
            <div>
              <span class="textColor-Hr-bule">{{ data.text2 }}</span>
              <span>{{ data.text21 }}</span>
            </div>
            <div>
              <span class="textColor-fs-red">{{ data.text3 }}</span>
              <span>{{ data.text31 }}</span>
            </div>
            <div>
              <span class="textColor-fs-green">{{ data.text4 }}</span>
              <span>{{ data.text41 }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextDt4'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center">
          <div class="col-6">
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class2" />
          </div>
          <div class="font-big text-left">
            <div>
              <span class="textColor-Hr-bule">{{ data.text1 }}</span>
              <span>{{ data.text11 }}</span>
            </div>
            <div>
              <span class="textColor-fs-red">{{ data.text2 }}</span>
              <span>{{ data.text21 }}</span>
            </div>
          </div>
        </div>
        <div class="gamerule-content-img-description text-center font-desc" :class="data.class">
          <span>{{ data.text3 }}</span>
          <span class="textColor-fs-red">{{ data.textCol }}</span>
          <span>{{ data.text4 }}</span>
          <span class="textColor-Hr-bule">{{ data.textCol2 }}</span>
          <span>{{ data.text5 }}</span>
        </div>
      </div>

      <div v-if="data.type === 'imageTextFish2'" class="gamerule-context-img-container my-2">
        <div class="gamerule-content-img-description text-center font-head">
          {{ data.textHead }}
        </div>
        <div class="d-flex justify-content-center py-2 px-4 font-bg2 flex-wrap">
          <div v-for="(item ,idx) in data.data" :key="idx">
            <div class="row container flex-column justify-content-center col-md-3 col-sm-6">
              <span class="textColor-bg2">{{item.text}}</span>
              <span>{{item.textCon}}</span>
              <img class="p-2 gamerule-single-img center"
              :class="item.class"
              :src="item.image" />
              <span>{{item.textFooter}}</span>
              <span>{{item.textFooter_2}}</span>
              <div>
                <span>{{item.textFooter_3}}</span>
                <span class="textColor-fs-red">{{item.textFooter_31}}</span>
              </div>
              <span class="textColor-bg2">{{item.textFooter_4}}</span>
            </div>
          </div>
          <!-- <div class="row container flex-column justify-content-center col-md-3 col-sm-6">
            <span class="textColor-bg2">{{data.text2}}</span>
            <span>{{data.textCon2}}</span>
              <img class="p-2 gamerule-single-img center"
              :class="data.class2"
              :src="data.image2" />
              <span>{{data.textFooter2}}</span>
              <span>{{data.textFooter2_2}}</span>
              <div>
                <span>{{data.textFooter2_3}}</span>
                <span class="textColor-fs-red">{{data.textFooter2_31}}</span>
              </div>
              <span class="textColor-bg2">{{data.textFooter2_4}}</span>
          </div>
          <div class="row container flex-column justify-content-center col-md-3 col-sm-6">
            <span class="textColor-bg2">{{data.text3}}</span>
            <span>{{data.textCon3}}</span>
              <img class="p-2 gamerule-single-img center"
              :class="data.class3"
              :src="data.image3" />
              <span>{{data.textFooter3}}</span>
              <span>{{data.textFooter3_2}}</span>
              <div>
                <span>{{data.textFooter3_3}}</span>
                <span class="textColor-fs-red">{{data.textFooter3_31}}</span>
              </div>
              <span class="textColor-bg2">{{data.textFooter3_4}}</span>
          </div>
          <div class="row container flex-column justify-content-center col-md-3 col-sm-6">
            <span class="textColor-bg2">{{data.text4}}</span>
            <span>{{data.textCon4}}</span>
              <img class="p-2 gamerule-single-img center"
              :class="data.class4"
              :src="data.image4" />
              <span>{{data.textFooter4}}</span>
              <span>{{data.textFooter4_2}}</span>
              <div>
                <span>{{data.textFooter4_3}}</span>
                <span class="textColor-fs-red">{{data.textFooter4_31}}</span>
              </div>
              <span class="textColor-bg2">{{data.textFooter4_4}}</span>
          </div> -->
        </div>
      </div>

      <div v-if="data.type === 'imageText'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column" :class="data.classMain">
          <div>
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class" />
          </div>
          <div class="gamerule-content-img-description font-desc">
            {{ data.text }}
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextPD2'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column" :class="data.classMain">
          <div class="d-flex align-items-center">
            <img class="p-2 gamerule-single-img" :src="data.image1" :class="data.class" />
            <img class="p-2 gamerule-single-img"
              :src="data.image2"
              :class="data.class && data.image2" />
          </div>
          <div class="gamerule-content-img-description font-desc">
            {{ data.text }}
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextCol'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column" :class="data.classMain">
          <div>
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class" />
          </div>
          <div class="gamerule-content-img-description font-desc">
            <span class="textColor-bg2">{{ data.text }}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextNew'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column">
          <div>
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class" />
          </div>
          <div class="gamerule-content-img-description font-desc">
            <span class="textHighlight mr-2">{{data.textHead}}</span>
            <span>{{data.text1}}</span>
            <span class="textHighlight-yellow mx-2">{{data.textSub}}</span>
            <span>{{data.text2}}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'yellowSubtext'" class="my-2">
        <div class="d-flex align-items-center flex-column">
          <div class="gamerule-content-img-description font-desc">
            <span>{{data.text}}</span>
            <span class="textHighlight-yellow mx-2" :class="data.classSub">{{data.textSub}}</span>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextspace'" class="gamerule-context-img-container my-2">
        <div class="d-flex align-items-center flex-column">
          <div>
            <img class="p-2 gamerule-single-img" :src="data.image" :class="data.class" />
          </div>
          <div class="font-desc d-flex mb-2">
            <div class="space">
              <div class="d-inline">{{data.text1}}</div>
            </div>
            <div>
              <div class="d-inline">{{data.text2}}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextNoborder'" class="gamerule-single-img-13cards">
        <div class="row mt-2">
          <div class="col-lg-5">
            <img class="ml-5 card-cp13-noboder" :src="data.image" />
          </div>
          <div class="col-lg-7 gamerule-content-img-description-nobody text-left">
            {{ data.text }}
          </div>
        </div>
      </div>

      <div v-if="data.type === 'imageTextRow'" class="gamerule-kang-img-container">
        <div class="row mt-2">
          <div class="col-lg-6 col-xs-6">
            <img class="pl-2 card-cp13" :src="data.image" />
          </div>
          <div class="col-lg-6 d-flex align-items-center
            gamerule-content-img-description font-desc text-left">
            {{ data.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-game',
  props: {
    title: String,
    value: Array,
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}
.font-head{
  font-size: 2.5vw;
}

.font-bg2{
  font-size: 1.2vw;
}

.font-desc {
  font-size: 1.1vw;
}
.font-big {
  font-size: 1.8vw;
}

.font-slot {
  font-size: 1.2vw;
}

.w-15 {
  width: 15% !important;
}
.w-20 {
  width: 20% !important;
}
.w-25 {
  width: 25% !important;
}
.w-30 {
  width: 30% !important;
}
.w-35 {
  width: 35% !important;
}
.w-40 {
  width: 40% !important;
}
.w-60 {
  width: 60% !important;
}
.w-70 {
  width: 70% !important;
}
.w-90 {
  width: 90% !important;
}
.card-cp13{
  width: 110%;
}
.card-cp13-noboder{
  width: 100%;
}
.kangRule {
  width: 32vw !important;
}

.textColor-bg2{
  color: #f89b0e;
  font-weight: bold;
}

.textColor-Bcr-blue{
  color: #3866ff;
}

.textColor-Bcr-purple{
  color: rgb(194, 0, 194);
  font-weight: bold;
}

.textColor-Hr-yellow{
  color: yellow;
  font-weight: bold;
}

.textColor-fs-red{
  color: red;
  font-weight: bold;
}

.textColor-fs-green{
  color: rgb(96, 243, 96);
  font-weight: bold;
}

.textColor-Hr-bule{
  color: #1927ee;
  font-weight: bold;
}

.textColor-Hr-pink{
  color: #ee19c0;
  font-weight: bold;
}

.textHighlight {
  font-size: 2.3vw;
  color: green;
  font-weight: bold;
}.textHighlight-yellow {
  font-size: 1.3vw;
  color: yellow;
  font-weight: bold;
}
@media only screen and (max-width: 768px) {
  .textHighlight-yellow {
  font-size: 2.3vw;
  color: yellow;
  font-weight: bold;
  }
}
.space {
  margin-right: 25vw !important;
  margin-left: 7vw !important;
}
.gamerule-content-description-subcolor {
  font-size: 1.1vw;
  padding: 0rem;
  color: green;
}
.gamerule-content-description-football {
  font-size: 1.1vw;
}
.gamerule-content-description-subcolor-bingo {
  font-size: 1.1vw;
  padding: 0rem;
  color: #f89b0e;
}
@media only screen and (max-width: 768px) {
  .gamerule-content-description-subcolor-bingo {
  font-size: 2.3vw;
  padding: 0rem;
  color: #f89b0e;
  }
}
.gamerule-content-img-description-nobody {
  font-size: 1.1vw;
  padding: 0 6rem;
}
.green-color {
  color: #49b432;
}
.red-color {
  color: red;
}
.yellow-color {
  color: yellow;
}
.blue-color {
  color: #29aeef;
}
@media only screen and (max-width: 768px) {

  .rule-slot{
    width:170%;
  }
  .font-desc {
    font-size: 2vw;
  }
  .font-slot{
    font-size: 3vw;
  }
  .font-bg2{
  font-size: 3vw;
}
  .card-cp13{
  width: 100%;
  }
  .card-cp13-noboder{
  width: 50%;
  }
  .gamerule-content-img-description-nobody  {
  font-size: 3.0vw;
  padding: 0 2rem;
  }
}
@media only screen and (max-width: 991px) {
  .card-cp13-noboder{
  width: 70%;
  }
  .gamerule-content-img-description-nobody {
  padding: 0 6rem;
  margin-top: 0.7rem;
}
}

.center {
  margin: 0 auto;
}

.margintop {
  margin-top: 2vw;
}
.left {
  display: flex;
  justify-items: start;
  margin: 0 2vw !important;
}

.pad-border {
  padding: 1vw 1vw !important;
}
@media only screen and (max-width: 768px) {
  .h-textSize  {
    font-size: 3vw;
  }
}

.subTextsize {
  font-size: 2vw;
}

@media only screen and (max-width: 400px){
  .font-slot{
    font-size: 3vw;
  }
  .font-bg2{
  font-size: 3vw;
}
}
</style>
